import { isStr } from '@formily/shared';
export * from './componentToSchema';
export * from './canvas';
export const EXP_RE = /^\s*\{\{([\s\S]*)\}\}\s*$/;
export const isExpression = (exp) => {
    if (!isStr(exp))
        return false;
    return EXP_RE.test(exp);
};
export const matchComponent = (node, name) => {
    const { componentName } = node;
    if (typeof name === 'function') {
        return name(componentName);
    }
    return componentName === name;
};
export const findNodeByComponentName = (node, name) => {
    if (node.children.size === 0)
        return [];
    const res = [];
    node.children.forEach((item) => {
        if (matchComponent(item, name)) {
            res.push(item);
        }
    });
    return res;
};
export const findComponentsByNodes = (components, nodes) => {
    const ids = nodes.map((item) => item.id);
    const res = components.filter((item) => ids.includes(item.props.componentId));
    return res;
};
export const uuid = () => {
    return Math.random().toString(36).slice(2);
};
